import {CompanyScoreType} from "@SearchResults/features/sidebar/features/companyFilters/types/CompanyScore.type";
import {CompanyScoresArray} from "@SearchResults/features/sidebar/features/companyFilters/constants/CompanyScoreTreshholds";
import RouteType from "@Route/types/Route.type";

/**
 * Determines which company score ranges have visible routes after filtering
 */
export default function getVisibleCompanyScores(routes: RouteType[]): CompanyScoreType[] {
    const visibleScores: CompanyScoreType[] = []
    
    for (const scoreRange of CompanyScoresArray) {
        // Check if any route has a rating within this score range
        const hasRoutesInRange = routes.some((route) => {
            const rating = parseFloat(route.ratings.companyRating.score)
            return rating >= scoreRange.from && rating < scoreRange.to
        })
        
        if (hasRoutesInRange) {
            visibleScores.push(scoreRange)
        }
    }
    
    return visibleScores
}
